import { MultiSelectDropdown } from '@platform/components';
import { UseFormRegisterReturn } from 'react-hook-form';
import { ProjectType } from '../dashboard/my-projects';

type RoleTypeSelectionDropdownProps = {
  selectedRoleType: string[];
  onRoleTypeSelectionChange: (RoleType: string[]) => void;
  register?: () => UseFormRegisterReturn<string>;
  errors?: Record<string, { message: string } | undefined>;
  label: string;
  placeholder?: string;
  selectionLimit?: number;
};
export const RoleTypeSelectionDropdown = ({
  selectedRoleType,
  onRoleTypeSelectionChange,
  register,
  errors,
  placeholder,
  label,
  selectionLimit,
}: RoleTypeSelectionDropdownProps) => {
  const roleOptions = [
    { label: ProjectType.coach },
    { label: ProjectType.mentor },
    { label: ProjectType.connector },
    { label: ProjectType.consultant },
    { label: ProjectType.trainer },
  ];

  return (
    <MultiSelectDropdown
      register={register}
      selectedItems={selectedRoleType}
      onSelectionChange={onRoleTypeSelectionChange}
      placeholder={placeholder || 'Select roles'}
      options={roleOptions}
      selectionLimit={selectionLimit}
      label={label}
      error={errors?.languages?.message}
      filterable={false}
    />
  );
};
